import { useRefinementList } from 'react-instantsearch';

const useFacetItems = () => {
  const {
    items: targetAudienceItems,
  } = useRefinementList({ attribute: 'targetAudience' });
  const {
    items: themeItems,
  } = useRefinementList({ attribute: 'theme' });

  return {
    targetAudience: targetAudienceItems,
    theme: themeItems,
    empty: targetAudienceItems.length === 0 && themeItems.length === 0,
  };
};

export default useFacetItems;

